import { STEPS } from "../../lib/stepConfig";
import { Check } from "lucide-react";
import { Box, Typography } from "@mui/material";

export default function StepIndicator({ currentStep, completedSteps }) {
  return (
    <Box
      sx={{
        mb: 3,
        width: "100%",
        overflowX: "auto",
        pb: 1,
        "&::-webkit-scrollbar": { height: 4 },
      }}
    >
      <Box sx={{ display: "flex", gap: 1, minWidth: "max-content", px: 0.5 }}>
        {STEPS.map((step) => {
          const Icon = step.icon;
          const isActive = currentStep === step.id;
          const isCompleted = completedSteps?.includes(step.id);

          return (
            <Box
              key={step.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 1,
                borderRadius: 2,
                fontSize: "0.75rem",
                fontWeight: 600,
                transition: "all 0.2s",
                whiteSpace: "nowrap",
                ...(isActive
                  ? {
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      boxShadow: 2,
                    }
                  : isCompleted
                  ? {
                      bgcolor: "success.light",
                      color: "success.dark",
                      opacity: 0.8,
                    }
                  : {
                      bgcolor: "action.hover",
                      color: "text.secondary",
                    }),
              }}
            >
              {isCompleted && !isActive ? (
                <Check size={14} />
              ) : (
                <Icon size={14} />
              )}
              <Typography
                variant="caption"
                sx={{
                  fontWeight: "inherit",
                  display: { xs: "none", sm: "inline" },
                }}
              >
                {step.title}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: "inherit",
                  display: { xs: "inline", sm: "none" },
                }}
              >
                {step.id}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
